import { Card, CardActionArea, CardContent, Grid, Typography } from "@mui/material";
import { NavLink as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  BookingFollowUpType,
  FollowUpTypeCountRow,
} from "../../process/types/processTypes";
import { countForFollowUpType } from "../utils/followUpHelpers";

interface Props {
  counts?: FollowUpTypeCountRow[];
  loading?: boolean;
}

const CARDS: { type: BookingFollowUpType; labelKey: string; path: string }[] = [
  {
    type: BookingFollowUpType.medical,
    labelKey: "followUps.medical",
    path: "/app/follow-ups",
  },
  {
    type: BookingFollowUpType.tasheer,
    labelKey: "followUps.tasheer",
    path: "/app/follow-ups",
  },
  {
    type: BookingFollowUpType.embassy,
    labelKey: "followUps.embassy",
    path: "/app/follow-ups",
  },
  {
    type: BookingFollowUpType.flight,
    labelKey: "followUps.flight",
    path: "/app/follow-ups",
  },
];

export function FollowUpDashboardCards({ counts, loading }: Props) {
  const { t } = useTranslation();

  return (
    <Grid container spacing={2} sx={{ mt: 1 }}>
      {CARDS.map((card) => {
        const active = countForFollowUpType(counts, card.type);
        return (
          <Grid item xs={12} sm={4} key={card.type}>
            <Card
              elevation={0}
              sx={{
                borderRadius: 3,
                border: "1px solid",
                borderColor: "divider",
              }}
            >
              <CardActionArea component={RouterLink} to={card.path}>
                <CardContent>
                  <Typography variant="overline" color="text.secondary">
                    {t("followUps.title")}
                  </Typography>
                  <Typography variant="h6" fontWeight={700}>
                    {t(card.labelKey)}
                  </Typography>
                  <Typography variant="h4" color="primary.main" fontWeight={800}>
                    {loading ? "…" : active}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {t("followUps.activeQueue")}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
}
